import $ from 'jquery';
import { logError as reportParsingError } from 'remoteLogging';
import { ParsedRequirementNode } from './requirementNodesProcessor';

export const LabelGenerator = {
	addLabel(fieldNode: JQuery, requirementsNode: ParsedRequirementNode) {
		if (isNoneLabelRequirement(requirementsNode)) {
			return; // skip this field
		}

		let labelNode;
		if (isImageLabelRequirement(requirementsNode)) {
			addLabelNodeIntoFieldNode(fieldNode, generateImageNode(requirementsNode));
		} else {
			labelNode = LabelGenerator.generateInputLabelNode(requirementsNode);
			addLabelNodeIntoFieldNode(fieldNode, labelNode);
		}
	},

	addStandaloneLabel(fieldNode: JQuery, requirementsNode: ParsedRequirementNode) {
		if (isImageLabelRequirement(requirementsNode)) {
			addLabelNodeIntoFieldNode(fieldNode, generateImageNode(requirementsNode));
		} else {
			this.addStandaloneText(fieldNode, requirementsNode);
		}
	},

	addStandaloneText(fieldNode: JQuery, requirementsNode: ParsedRequirementNode) {
		if (isNoneLabelRequirement(requirementsNode)) {
			return; // skip this field
		}

		let labelNode;
		if (isHeading(requirementsNode)) {
			labelNode = generateHeadingTextNode(requirementsNode);
		} else {
			labelNode = generateStandaloneTextNode(requirementsNode);
		}
		addLabelNodeIntoFieldNode(fieldNode, labelNode);
	},

	generateInputLabelNode(requirementsNode: ParsedRequirementNode) {
		const labelNode = $('<label />').attr('for', requirementsNode.credential.id);
		labelNode.addClass('label');
		addLabelText(requirementsNode, labelNode);
		addAppropriateLabelClass(labelNode, requirementsNode.label.type);
		return labelNode;
	},
};

function isImageLabelRequirement(requirementsNode: ParsedRequirementNode) {
	return requirementsNode.label.type === 'image';
}

function isNoneLabelRequirement(requirementsNode: ParsedRequirementNode) {
	return !requirementsNode.label || requirementsNode.label.type === 'none';
}

function isHeading(requirementsNode: ParsedRequirementNode) {
	return requirementsNode.label.type === 'heading';
}

function generateImageNode(requirementsNode: ParsedRequirementNode) {
	return $('<img/>').attr('src', requirementsNode.label.src);
}

function generateHeadingTextNode(requirementsNode: ParsedRequirementNode) {
	const headingTextNode = $('<span/>');
	addLabelText(requirementsNode, headingTextNode);
	return $('<h1/>').append(headingTextNode);
}

function generateStandaloneTextNode(requirementsNode: ParsedRequirementNode) {
	let labelNode;
	labelNode = $('<div />');
	labelNode.addClass('standaloneText');
	const content = $('<div />').addClass('textContent');
	addLabelText(requirementsNode, content);
	labelNode.append(content);
	addAppropriateLabelClass(labelNode, requirementsNode.label.type);
	return labelNode;
}

// The functions addLabelText and addNodesAsHtml are taken from native Receiver, replacing an earlier implementation that
// ignored styling for labels that were entirely enclosed within style tags.
function addLabelText(requirementsNode: ParsedRequirementNode, labelNode: JQuery) {
	try {
		const unparsedText = '<x>' + requirementsNode.label.text + '</x>';
		const labelTextAsXmlDoc = $($.parseXML(unparsedText));
		const labelXmlNodes = labelTextAsXmlDoc.contents().contents();
		addNodesAsHtml(labelNode, labelXmlNodes);
	} catch (e) {
		reportParsingError(
			"The label content is not valid: '" + requirementsNode.label.text + "'"
		);
	}
}

function addNodesAsHtml(parent: JQuery, xmlNodes: JQuery) {
	xmlNodes.each(function (this: Element) {
		if (this.nodeType === 3) {
			// text node
			parent.append(document.createTextNode(this.nodeValue));
		} else if (this.nodeType === 1) {
			// element node, only look at ones we know
			if (
				this.tagName === 'B' ||
				this.tagName === 'b' ||
				this.tagName === 'I' ||
				this.tagName === 'i' ||
				this.tagName === 'U' ||
				this.tagName === 'u'
			) {
				const tagNode = $('<' + this.tagName + '/>');
				parent.append(addNodesAsHtml(tagNode, $(this).contents()));
			} else {
				reportParsingError('Unsupported tag in a label: ' + this.tagName);
			}
		}
	});

	return parent;
}

function addAppropriateLabelClass(labelNode: JQuery, labelType: string) {
	labelNode.addClass('label');

	switch (labelType) {
		case 'plain':
			labelNode.addClass('plain');
			break;

		case 'information':
			labelNode.addClass('information');
			labelNode.attr('role', 'alert');
			break;

		case 'warning':
			labelNode.addClass('warning');
			labelNode.attr('role', 'alert');
			break;

		case 'error':
			labelNode.addClass('error');
			labelNode.attr('role', 'alert');
			break;

		case 'confirmation':
			labelNode.addClass('confirmation');
			labelNode.attr('role', 'alert');
			break;

		case 'inprogress':
			labelNode.addClass('inprogress');
			labelNode.attr('role', 'alert');
			break;
	}
}

function addLabelNodeIntoFieldNode(fieldNode: any, labelNode: any) {
	const leftDiv = $('<div/>').addClass('left').append(labelNode);
	fieldNode.append(leftDiv);
}
